import { render, staticRenderFns } from "./TextWithButton.vue?vue&type=template&id=446b94b6&"
import script from "./TextWithButton.vue?vue&type=script&lang=js&"
export * from "./TextWithButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports